<template>
  <v-list v-if="showStationFeatures">
    <v-divider class="pb-2 mr-10"></v-divider>
    <v-list-item-subtitle class="pb-0 pl-5">{{
      $t("virtualStations")
    }}</v-list-item-subtitle>
    <template v-for="station in stationFeatures">
      <virtual-station-point
        v-if="station.type === 'Point'"
        :station="station"
        :key="station.id"
        :geometry="station.id"
        :activeTimestep="activeRasterLayer.datetime"
        :close="close"
      ></virtual-station-point>
      <virtual-station-polygon
        v-else
        :station="station"
        :key="station.id"
        :geometry="station.id"
        :activeTimestep="activeRasterLayer.datetime"
        :close="close"
      ></virtual-station-polygon>
    </template>
  </v-list>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VirtualStationPoint from "@/core/components/map/pop-up/VirtualStationPoint";
import VirtualStationPolygon from "@/core/components/map/pop-up/VirtualStationPolygon";

export default {
  name: "VirtualStationItem",
  components: {
    VirtualStationPolygon,
    VirtualStationPoint
  },
  props: ["coordinates", "close"],
  data: () => ({
    stationFeatures: []
  }),
  computed: {
    ...mapState("draw", ["virtualStations"]),
    ...mapState("raster", ["activeRasterLayer"]),
    ...mapGetters("draw", ["stationById"]),
    showStationFeatures() {
      return !!this.stationFeatures.length;
    }
  },
  methods: {
    async queryStationFeatures() {
      const map = this.$store.visualizeMap;
      const pixelCoordinates = map.project(this.coordinates);
      let layers = [];
      layers.push("gl-draw-polygon-fill-static.cold");
      layers.push("gl-draw-point-static.cold");
      layers.push("gl-draw-polygon-fill-static.hot");
      layers.push("gl-draw-point-static.hot"); // added in order to get new points by set station button visible in pop up

      let features = [];
      features = map.queryRenderedFeatures(pixelCoordinates, {
        layers: layers
      });

      this.stationFeatures = features.map(feature => {
        let stationCopy = { ...this.stationById(feature.properties.id) }; // shallow copy, but sufficient here
        stationCopy.type = feature.properties["meta:type"];
        if (!stationCopy.geometry) {
          // stationCopy already contains geometry for saved stations.
          // In case the station was not stored, we take it from the queryRenderedFeatures
          stationCopy.geometry = feature.geometry;
        }
        return stationCopy;
      });
    }
  },
  created() {
    this.queryStationFeatures();
  },
  watch: {
    virtualStations() {
      setTimeout(this.queryStationFeatures, 100);
    }
  }
};
</script>

<style scoped></style>
